import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { postAssessment } from "../../../../services/httpClient";
import LikertScale from "./LikertScale";
import SelectObjectTypeahead from "../../../ui/SelectObjectTypeahead";

interface CustomState {
  setViewAssessments: any;
  setCreateAssessmentWell: any;
  setCreateAssessmentCont: any;
  setCreateAssessmentCustom: any;
  fetchAssessments: any;
  family: any;
  readOnly?: boolean;
  questions: any;
  results?: any;
  subject?: string;
  assessDate?: string;
  setShowToast?: any;
  setToastText?: any;
  setToastBody?: any;
  setErrMsg: any;
}

const AssessmentCustom = ({
  setViewAssessments,
  setCreateAssessmentWell,
  setCreateAssessmentCont,
  setCreateAssessmentCustom,
  fetchAssessments,
  family,
  readOnly = false,
  questions,
  results,
  subject,
  assessDate,
  setShowToast,
  setToastText,
  setToastBody,
  setErrMsg,
}: CustomState) => {
  const { id } = useParams();
  const [familyUser, setFamilyUser] = useState<string>(subject ? subject : "unassigned");
  const selectableFamily = family.filter((f: any) => !f.isBanned);
  const [likertValues, setLikertValues] = useState<any[]>([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const mainRef = useRef();

  const handleScroll = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  };

  useEffect(() => {
    if (readOnly) {
      const count = Object.keys(results.fields).length;
      var likertList = [];
      for (let i = 1; i <= count; i++) {
        var obj = {
          key: i,
          value: results.fields[i],
        };
        likertList.push(obj);
      }
      setLikertValues(likertList);
    } else {
      const likertVals = questions?.question.map((q: any) => {
        return {
          key: q.key,
          value: null,
        };
      });
      setLikertValues(likertVals);

      if (selectableFamily.length === 1) {
        setFamilyUser(selectableFamily[0].id + "|" + selectableFamily[0].type);
      }
    }

    handleScroll(mainRef);
  }, []);

  useEffect(() => {
    if (likertValues.length > 0) {
      if (likertValues.every((item) => item.value !== null && item.value !== undefined && item.value !== "")) {
        setSubmitDisabled(false);
      }
    }
  }, [likertValues]);

  const onUpdateSubject = (e: any) => {
    setFamilyUser(e?.key ?? "unassigned");
    setErrMsg("");
  };

  const onClickSubmit = () => {
    setErrMsg("");
    var newSubject = {};
    if (familyUser === "unassigned") {
      newSubject = {
        id: 0,
      };
    } else {
      const [subjectId, subjectType] = familyUser.split("|");
      newSubject = {
        id: subjectId,
        type: subjectType,
      };
    }

    const assessSubmission = {
      assessmenttype: questions?.key,
      assessment_at: assessDate ? assessDate : new Date().toISOString(),
      fields: likertValues.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {}),
      subject: newSubject,
    };

    postAssessment(assessSubmission, id)
      .then((res: any) => {
        setViewAssessments(true);
        setCreateAssessmentWell(false);
        setCreateAssessmentCont(false);
        setCreateAssessmentCustom(false);
        fetchAssessments();
        setShowToast(true);
        setToastText("Assessment Created");
        setToastBody(questions?.name);
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  return (
    <>
      <Row ref={mainRef} className="my-0 py-0">
        <Col className="col-6">
          <SelectObjectTypeahead
            testId="household-member"
            label="Household Member"
            initialOption="Unassigned"
            value={familyUser ? familyUser : "unassigned"}
            options={[
              { key: "unassigned", name: "Unassigned" },
              ...selectableFamily.map((f: any) => ({ ...f, key: `${f.id}|${f.type}` })),
            ]}
            onUpdate={onUpdateSubject}
            readOnly={readOnly}
          />
        </Col>
      </Row>
      {questions?.question.map((q: any, index: number) => (
        <Card className="bg-light" key={index}>
          <Card.Body>
            <Row>
              <h5 className="pb-2 app-header-text">
                <label className="app-orange-text">{index + 1 + "."}</label>
                {" " + q.question}
              </h5>
            </Row>
            <LikertScale
              fields={q.fields}
              keyValue={likertValues[index]?.key}
              value={likertValues[index]?.value}
              setValues={setLikertValues}
              beginText=""
              endText=""
              readOnly={readOnly}
            />
          </Card.Body>
        </Card>
      ))}
      {!readOnly ? (
        <Row className="text-center pb-5">
          <Col></Col>
          <Col className="col-4">
            <Button className="app-secondary-color button" disabled={submitDisabled} onClick={() => onClickSubmit()}>
              Submit Results
            </Button>
          </Col>
          <Col></Col>
        </Row>
      ) : (
        <Row className="pb-5"></Row>
      )}
    </>
  );
};

export default AssessmentCustom;
